import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

var mountNode = document.getElementById('regisPhotography');
ReactDOM.render(<App />, mountNode);
